export class UIConfigModel {
  // Simple Configs
  bookmarkTour: boolean;
  annotations: boolean;
  audio: boolean;
  info: boolean;
  loadProgress: boolean;
  fullscreen: boolean;
  pan: boolean;
  zoomIn: boolean;
  zoomOut: boolean;
  zoom: boolean;
  center: boolean;
  cameraMode: boolean;
  objectTree: boolean;
  crossSection: boolean;
  dissect: boolean;
  isolate: boolean;
  xray: boolean;
  actionsTour: boolean;

  // Advanced Configs
  playPause: boolean | { tour: boolean };
  objectSlider: boolean | { objects: boolean };
  scrubber: boolean | { chapters: boolean; tour: boolean };
  tour: boolean | { chapters: boolean };
}
